import { useMutation } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { constantsData, selectionsData, statusTypesData } from "@/data";
import { editDistributeMediaFilesMutation, editDistributionMetadataMutation } from "@/graph";
import { openAlert, toggleDistributionDrawer } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useEditDistribution = (type, setModalData) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [editDistributionAction, { loading }] = useMutation(
        type === selectionsData.data.editDistributionTypes.find((item) => item.label.toLowerCase() === "metadata").value
            ? editDistributionMetadataMutation
            : editDistributeMediaFilesMutation,
    );

    const editDistribution = async (clientId, jobId, releaseId, territoryId) => {
        try {
            await editDistributionAction({
                onCompleted: () => {
                    dispatch(openAlert(t("messages.distributionMsgs.edit"), statusTypesData.success));

                    setModalData((prevState) => ({
                        ...prevState,
                        open: false,
                    }));

                    dispatch(toggleDistributionDrawer(false));
                },
                variables: {
                    clientId,
                    jobId,
                    releaseId,
                    territoryId,
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        }
    };

    return {
        editDistribution,
        loading,
    };
};

export default useEditDistribution;
